import clsx from 'clsx';

export interface SpinnerProps {
  className?: string;
  size?: 'small' | 'medium' | 'large';
}
export const Spinner = (props: SpinnerProps) => {
  return (
    <svg
      style={{ borderTop: '0px' }}
      className={clsx(props.className, 'animate-spin', {
        'size-4': props.size === 'small',
        'size-6': props.size === 'medium',
        'size-8': props.size === 'large',
      })}
      viewBox="0 0 24 24"
    >
      <circle className="stroke-gray-300" cx="12" cy="12" r="10" fill="none" strokeWidth="4" />
      <path
        className="fill-indigo-600"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
};
